import { render } from "./ShoeDetail.vue?vue&type=template&id=496725a4&scoped=true"
import script from "./ShoeDetail.vue?vue&type=script&lang=js"
export * from "./ShoeDetail.vue?vue&type=script&lang=js"

import "./ShoeDetail.vue?vue&type=style&index=0&id=496725a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496725a4"]])

export default __exports__